import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgThumbsUp = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M25.594 8.763a2.625 2.625 0 0 0-1.969-.888H17.5v-1.75a4.375 4.375 0 0 0-4.375-4.375.875.875 0 0 0-.783.483L8.21 10.5H3.5a1.75 1.75 0 0 0-1.75 1.75v9.625a1.75 1.75 0 0 0 1.75 1.75h18.813a2.625 2.625 0 0 0 2.605-2.297l1.312-10.5a2.626 2.626 0 0 0-.636-2.065ZM3.5 12.25h4.375v9.625H3.5V12.25Zm20.993-1.64-1.312 10.5a.874.874 0 0 1-.869.765H9.626V11.582L13.64 3.55a2.625 2.625 0 0 1 2.11 2.575V8.75a.875.875 0 0 0 .875.875h7a.875.875 0 0 1 .868.984Z" />
  </svg>
);
export default SvgThumbsUp;
